import React, { useState } from "react";

import "./styles.less";

import { useTranslation } from "react-i18next";
import { Column, Table } from "../NormalTable";
import { AuthingButton } from "../../../../components/AuthingButton";

export const SolutionTable = () => {
  const { t } = useTranslation();
  const data = [
    {
      nametype: t("solution.okta.table.fun"),
      descript: `<a href="https://docs.authing.cn/v2/guides/connections/social.html" class='table-href'">${t(
        "solution.okta.table.fun1"
      )}</a>`,
      dataIndex: "descript",
      okta: "unchecked",
      authing: "checked",
    },
    {
      nametype: (
        <img
          src="//files.authing.co/authing-website/okta-logo-table.png"
          alt="authing"
          style={{ width: 90 }}
        />
      ),
      descript: t("solution.okta.table.fun2"),
      dataIndex: "okta",
      okta: "unchecked",
      authing: "checked",
    },
    {
      nametype: (
        <img
          src="//files.authing.co/authing-website/authing-logo-0830.png"
          alt="authing"
          style={{ width: 100 }}
        />
      ),
      descript: t("solution.okta.table.fun3"),
      dataIndex: "authing",
      okta: `<div style="text-align:center">${t(
        "solution.okta.table.remark"
      )}</div>`,
      authing: `<div style="text-align:center">>99.28%</div>`,
    },
    {
      descript: t("solution.okta.table.fun4"),
      dataIndex: "",
      okta: `<div style="text-align:center">${t(
        "solution.okta.table.remark"
      )}</div>`,
      authing: `<div style="text-align:center"><10s-5s</div>`,
    },
    {
      descript: t("solution.okta.table.fun5"),
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: t("solution.okta.table.fun6"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/reference/sdk-for-ios/apis/user/" class='table-href'">${t(
        "solution.okta.table.fun7"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v3/reference/sdk/java/install.html" class='table-href'">${t(
        "solution.okta.table.fun8"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/concepts/authentication.html#oidc-oauth2-0-saml-ad-ldap-%E7%A4%BE%E4%BC%9A%E5%8C%96%E7%99%BB%E5%BD%95" class='table-href'">${t(
        "solution.okta.table.fun9"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/guides/migrations/custom-password-script/" class='table-href'">${t(
        "solution.okta.table.fun10"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: t("solution.okta.table.fun11"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/guides/webhook/" class='table-href'">${t(
        "solution.okta.table.fun12"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/guides/customize/domain/customized-domain.html" class='table-href'">${t(
        "solution.okta.table.fun13"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/concepts/mfa.html#%E4%BA%BA%E8%84%B8%E8%AF%86%E5%88%AB" class='table-href'">${t(
        "solution.okta.table.fun14"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: t("solution.okta.table.fun15"),
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/guides/authorization/" class='table-href'">${t(
        "solution.okta.table.fun16"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://www.authing.cn/learn/sso" class='table-href'">${t(
        "solution.okta.table.fun17"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://www.authing.cn/mfa" class='table-href'">${t(
        "solution.okta.table.fun18"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
  ];
  const renderChecked = (value) => {
    const iconStyl = {
      color: "#215AE5",
      textAlign: "center",
      margin: "0 auto",
      display: "block",
      // color: "rgba(57, 106, 255, 0.8)",
    };
    const uniconStyl = {
      color: "#FB9926",
      textAlign: "center",
      margin: "0 auto",
      display: "block",
      fontSize: "19px",
    };
    const checkedIcon = (
      <div>
        <i className="icon authing-icon authing-wancheng" style={iconStyl}></i>
      </div>
    );
    const uncheckedIcon = (
      <div>
        <i
          className="icon authing-icon authing-close-circle-fill1"
          style={uniconStyl}
        ></i>
      </div>
    );
    if (value === "checked") {
      return checkedIcon;
    } else if (value === "unchecked") {
      return uncheckedIcon;
    } else {
      return <div dangerouslySetInnerHTML={{ __html: value }}></div>;
    }
  };
  return (
    <>
      <div className="solution-table">
        <div className="inner">
          <div>
            <div className="solution-table-title">
              {t("solution.okta.table.title")}
            </div>
            <div className="solution-table-subtitle">
              {t("solution.okta.table.description1")}

              {t("solution.okta.table.description2")}
            </div>
            <div className="solution-button-warp">
              <AuthingButton
                style={{ marginRight: 24 }}
                onClick={() => {
                  window.open(
                    "https://www.authing.cn/authingform?fromTag=Okta功能对比"
                  );
                }}
              >
                {t("solution.okta.table.learnMore")}
              </AuthingButton>
              <AuthingButton
                mode="light"
                onClick={() => {
                  window.open(
                    "https://www.authing.cn/authingform?fromTag=Okta预约演示"
                  );
                }}
              >
                {t("solution.okta.table.showDemo")}
              </AuthingButton>
            </div>
          </div>
          <div className="solution-table-frame">
            <Table data={data}>
              {data.map((column) => {
                if (column.nametype) {
                  return (
                    <Column
                      title={column.nametype}
                      dataIndex={column.dataIndex}
                      render={renderChecked}
                      extra={column.extra}
                      descript={column.descript}
                    />
                  );
                } else {
                  return <></>;
                }
              })}
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};
